export default __webpack_public_path__ + "static/media/food-placeholder.2a8e9309.jpeg";